import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgAgent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333zm0 2c1.107 0 2 .894 2 2 0 1.107-.893 2-2 2s-2-.893-2-2c0-1.106.893-2 2-2zM8 12.8a4.8 4.8 0 0 1-4-2.147C4.02 9.327 6.667 8.6 8 8.6c1.327 0 3.98.727 4 2.053A4.8 4.8 0 0 1 8 12.8z",
		fillRule: "nonzero"
	})
});
export default SvgAgent;
